import {
  createElement,
  addClass,
  findElements,
  addEventListener,
  addStyle,
  getScrollTop,
  getWindowSize,
  getAbsoluteOffset,
} from 'dom-helper';
import Browser from 'browser';
import Logger from '../utils/logger';
import {
  BLOCKER_CLASS,
  DIALOG_CLASS,
  CONTENT_CLASS,
  MOBILE_WIDTH_LIMIT,
} from '../config/constants';

const DIALOG_STYLE = {
  position: 'absolute',
  margin: 0,
  opacity: 0.5,
  zIndex: 10102,
  'box-sizing': 'border-box',
};

const CONTENT_STYLE = {
  position: 'relative',
  backgroundColor: 'white',
  // border: '1px solid #e5e5e5',
  borderRadius: '3px',
  // webkitBoxShadow: '0 0 2px 2px rgba(224, 224, 224, 0.45)',
  // mozBoxShadow: '0 0 2px 2px rgba(224, 224, 224, 0.45)',
  // boxShadow: '0 0 2px 2px rgba(224, 224, 224, 0.45)',
  // outline: 0,
  height: '100%',
  width: '100%',
  webkitBoxSizing: 'content-box',
  mozBoxSizing: 'content-box',
  boxSizing: 'content-box',
};

const BLOCKER_STYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  // opacity: 0,
  backgroundColor: 'rgba(0,0,0,0.65)',
  zIndex: 10101, /* never big enough */
};

const FRAME_STYLE = {
  borderRadius: '3px',
  display: 'block',
  height: 'inherit',
  width: 'inherit',
  backgroundColor: 'black',
};

const EXIT_STYLE = {
  position: 'absolute',
  top: '-50px',
  height: '40px',
  width: '40px',
  right: '-8px',
  fontSize: '40px',
  color: 'white',
  verticalAlign: 'top',
};

const MODAL_DIMENSIONS = {
  mobile: {
    width: '95%',
    height: '30%',
  },
  desktop: {
    width: '768px',
    height: '500px',
  },
};

const MIN_TOP = 45;

export default class Modal {

  static show(contentHtml, heightOffset = null) {
    const doc = Browser.getDocument();
    const elBlocker = createElement('div');
    const elDialog = createElement('div');
    const elContent = createElement('div');
    const elFrame = createElement('div');
    const elExit = createElement('div');

    elExit.innerHTML = '&times';

    addClass(elBlocker, BLOCKER_CLASS);
    addClass(elDialog, DIALOG_CLASS);
    addClass(elContent, CONTENT_CLASS);

    addStyle(elBlocker, BLOCKER_STYLE);
    addStyle(elDialog, DIALOG_STYLE);
    addStyle(elContent, CONTENT_STYLE);
    addStyle(elExit, EXIT_STYLE);

    doc.body.appendChild(elBlocker);
    doc.body.appendChild(elDialog);

    elContent.appendChild(elExit);
    elDialog.appendChild(elContent);

    elFrame.innerHTML = contentHtml;

    addStyle(elDialog, this.computePosition(heightOffset));
    addStyle(elDialog, { opacity: 1 });
    addStyle(elFrame, FRAME_STYLE);

    addEventListener(elBlocker, 'click', () => {
      Logger.debug('Clicked on blocker. Closing the modal.');
      this.remove();
    });

    addEventListener(elExit, 'click', () => {
      Logger.debug('Clicked on blocker. Closing the modal.');
      this.remove();
    });

    elContent.appendChild(elFrame);
  }

  static remove() {
    findElements(`.${BLOCKER_CLASS}`).forEach(el => el.parentNode.removeChild(el));
    findElements(`.${DIALOG_CLASS}`).forEach(el => el.parentNode.removeChild(el));
    findElements(`.${CONTENT_CLASS}`).forEach(el => el.parentNode.removeChild(el));
  }

  static getMobileModalDimensions() {
    return MODAL_DIMENSIONS.mobile;
  }

  static getDesktopModalDimensions() {
    return MODAL_DIMENSIONS.desktop;
  }

  static computePosition(heightOffset = null) {
    const windowSize = getWindowSize();
    const minTop = (getScrollTop() + windowSize.height) * 0.15;
    let dimensions;

    if (windowSize.width < MOBILE_WIDTH_LIMIT) {
      Logger.debug('Setting Modal for mobile.');
      dimensions = this.getMobileModalDimensions();
    } else {
      Logger.debug('Setting Modal for desktop.');
      dimensions = this.getDesktopModalDimensions();
    }

    const left = `${getAbsoluteOffset(dimensions.width, windowSize.width)}px`;
    let top = getAbsoluteOffset(dimensions.height, windowSize.height) + getScrollTop() + 20;
    if (top < minTop) {
      top = minTop;
    }
    const position = 'absolute';
    const width = dimensions.width;
    const height = dimensions.height;

    if (heightOffset) {
      Logger.debug('Setting top to heightOffset:', heightOffset);
      top = heightOffset;
    }

    if (top < MIN_TOP) {
      top = MIN_TOP;
    }

    top = `${top}px`;

    return {
      top,
      left,
      position,
      width,
      height,
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/modal.js